
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AdvertisersPage = lazy(() => import('../pages/advertisers/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />
  },
  {
    path: '/advertisers',
    element: <AdvertisersPage />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
